var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMongo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.82905 15.9372L8.43008 15.805C8.43008 15.805 8.48321 13.7862 7.75274 13.6444C7.27462 13.0876 7.8234 -10.1243 9.57121 13.5652C9.23959 13.7334 8.98585 14.0233 8.86305 14.3743C8.79724 14.8927 8.78584 15.4165 8.82905 15.9372Z",
    fill: "url(#paint0_linear_670_733)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04506 13.9876C10.1073 13.1879 10.9209 12.1032 11.3911 10.8595C11.8613 9.61581 11.9689 8.2642 11.7013 6.96178C10.9204 3.51663 9.07109 2.384 8.87188 1.95156C8.69999 1.68229 8.55328 1.39775 8.43359 1.10156L8.58075 10.7007C8.58075 10.7007 8.27581 13.6343 9.04506 13.9876Z",
    fill: "url(#paint1_linear_670_733)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2288 14.1148C8.2288 14.1148 4.97702 11.9 5.16508 7.98203C5.18262 6.80087 5.45345 5.63724 5.95925 4.56972C6.46506 3.5022 7.19407 2.55566 8.09705 1.79403C8.20257 1.70438 8.28641 1.59198 8.34226 1.46528C8.39811 1.33858 8.42452 1.20087 8.41952 1.0625C8.62192 1.49812 8.58899 7.56659 8.61024 8.27634C8.69258 11.0372 8.45671 13.5936 8.2288 14.1148Z",
    fill: "url(#paint2_linear_670_733)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_670_733",
    x1: 6.14711,
    y1: 8.63377,
    x2: 10.7327,
    y2: 10.1899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#999875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#9B9977"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683,
    stopColor: "#A09F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#A9A889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#B7B69A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#C9C7B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#DEDDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#F8F6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF9EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_670_733",
    x1: 7.829,
    y1: 1.03297,
    x2: 9.85627,
    y2: 13.6921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48A547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F9143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_670_733",
    x1: 4.88536,
    y1: 8.36986,
    x2: 10.3257,
    y2: 6.54789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41A247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#4BA74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#67B554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B655"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongo);
export default __webpack_public_path__ + "static/media/mongo.3c477a1a75ce8ec59605f27ab2cd556c.svg";
export { ForwardRef as ReactComponent };